import(/* webpackMode: "eager" */ "/buggy-mccodeface-academy/app/globals.css");
import(/* webpackMode: "eager" */ "/buggy-mccodeface-academy/components/sentry-provider.tsx");
import(/* webpackMode: "eager" */ "/buggy-mccodeface-academy/components/theme-provider.tsx");
import(/* webpackMode: "eager" */ "/buggy-mccodeface-academy/components/ui/toaster.tsx");
import(/* webpackMode: "eager" */ "/buggy-mccodeface-academy/components/ui/tooltip.tsx")